import Header from "./Header";
import NavBar from "./NavBar";
import { Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { useEffect } from "react";
import { setActionLog } from "../utils/util";

const MainLayout = () => {
  const location = useLocation();
  const {isWorker} = useAuth();
  useEffect(()=>{
    setActionLog({eventType:'PAGE_VIEW',title:'화면진입'});
  },[location.pathname]);
  return (
    <div
      style={{ display: "flex", flexDirection: "column" }}
    >
      <div style={{ display: "flex", flex: 1 }}>
        {!isWorker && <NavBar />}
        <main style={{ flex: 1 }}>
          <Header />
          <div style={{
            height: "calc(100vh - 60px)",
            padding: "1rem"
          }}>
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};
export default MainLayout;
